import { useEffect, useState } from 'react';
import globalWindow from '@shared/core/globals';
import { createPreviewMessageEventHandler, sendMessageToParentWindow } from '@shared/utils/previewMessageBus';
import type { PreviewIframeMessage, PreviewScaleChange } from '@shared/utils/previewMessageBus';

export const usePreviewIframeScale = (enabled: boolean) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!enabled) return;
    const handler = createPreviewMessageEventHandler((message: PreviewIframeMessage) => {
      if (message.action === 'previewScaleChange') {
        const next = (message as PreviewScaleChange).value.scale;
        if (next > 0) {
          setScale(next);
        }
      }
    }, 'joy');
    globalWindow.addEventListener?.('message', handler, false);
    sendMessageToParentWindow({ action: 'requestIframeScaleValue', source: 'joyPreview' });
    return () => {
      globalWindow.removeEventListener?.('message', handler, false);
    };
  }, [enabled]);

  return scale;
};
